import type React from "react";

/**
 * 詳細画面の下に貼り付くボタン列の帯（PRODUCT_DEV-1031）
 *
 * 商談詳細（`ActionButtons` / `ReviewActionButtons`）・議事録詳細・メモ詳細・メモ一覧で、
 * 帯の形とボタンの高さがばらばらだった（議事録とメモはボタン 44px・上が透けるグラデーション、
 * 商談は 56px 以上・白い帯）。**商談詳細の形にそろえ**、ここを正本にする。
 *
 * - 帯: グローバルナビの直上（`bottom-16`）に白・上に区切り線・上下 12px
 * - ボタン: 上下 16px＋2px の枠（文字 16px と合わせて 60px）・pill。塗りは各画面 1 つだけ。
 *   枠は商談詳細の「コピー」（白抜き）と高さをそろえるためで、塗りのボタンにも同じ色の枠を付ける
 *
 * ⚠ 帯の背景にグラデーションや backdrop-blur を使わない（DESIGN.md）。
 */
export function DetailActionBar({
  children,
  positionClassName = "fixed bottom-16 left-0 right-0 z-10",
}: {
  children: React.ReactNode;
  /**
   * 置き場所だけを変えるとき（PRODUCT_DEV-1184）。管理画面（AdminLayout）の中では
   * PC で下のナビが無く左にサイドバーがあるので `fixed bottom-16 md:bottom-0 left-0 right-0 md:left-80 z-20`
   * を渡す（顧客・部署の一覧の下部バーと同じ）。帯の見た目は変えない。
   */
  positionClassName?: string;
}) {
  return (
    <div className={`${positionClassName} bg-white border-t border-neutral-200 px-4 py-3`}>
      {children}
    </div>
  );
}

/**
 * 帯の上に出すもの（`Toast` の `aboveActionBar`）を置く位置（PRODUCT_DEV-1044 10/05）。
 * ナビ 64px ＋ 帯（上下 12px ＋ ボタン 60px）＋ 8px のすき間。
 * ⚠ **帯の余白やボタンの高さを変えたら、ここも直す。** 直さないとトーストがまた帯のボタンに被る。
 */
export const DETAIL_BAR_TOAST_BOTTOM = "bottom-[156px]";

/** 帯の中の主ボタン（塗り）。各画面 1 つだけ。 */
export const DETAIL_BAR_PRIMARY =
  "w-full min-w-0 whitespace-nowrap py-4 border-2 border-primary rounded-full font-bold transition-colors flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark hover:border-primary-dark text-white disabled:opacity-50";

/** 帯の中の「キャンセル」「戻る」（灰色の塗り）。商談詳細の編集中のキャンセルと同じ。 */
export const DETAIL_BAR_CANCEL =
  "w-full min-w-0 whitespace-nowrap py-4 border-2 border-neutral-200 rounded-full font-medium transition-colors flex items-center justify-center gap-2 bg-neutral-200 hover:bg-neutral-300 hover:border-neutral-300 text-neutral-700";
